import { apiCall, apiClient } from '../client/apiClient';

export const getTranslationsForLocale = async (locale: string) => {
  const data = await apiCall(
    apiClient.GET('/translations/locales/{locale}', {
      params: { path: { locale } }
    })
  );
  return data;
};
